import styles from "./fields.module.css";

const Fields = () => {
  return (
    <div className={styles.fields}>
      <div className={styles.text}>
        Areas of Computer Science that I'm interested in them and am looking to
        research, include:
      </div>
      <div className={`${styles.list} grid gap-4 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3`}>
        <li className={``}>
          <i className="far fa-cogs"></i>
          <span>Software Engineering</span>
        </li>
        <li className={``}>
          <i className="far fa-code"></i>
          <span>Software Development</span>
        </li>
        <li className={``}>
          <i className="far fa-robot"></i>
          <span>Artificial Intelligence</span>
        </li>
        <li className={``}>
          <i className="far fa-brain"></i>
          <span>Machine Learning</span>
        </li>
        <li className={``}>
          <i className="far fa-chart-network"></i>
          <span>Deep Learning</span>
        </li>
        <li className={``}>
          <i className="far fa-eye"></i>
          <span>Computer Vision</span>
        </li>
        <li className={``}>
          <i className="far fa-language"></i>
          <span>Natural Language Processing</span>
        </li>
      </div>
    </div>
  );
};

export default Fields;
